module.exports = "/images/knowledge_asset_cover_placeholder.jpg?9a87b081b5478e58ec59dfd4fdfced3b";